import useAxios from 'hooks/useAxios';

export async function getStreamingConfig() {
  const api = useAxios();

  try {
    const res = await api.get('/streaming-config');
    return res;
  } catch (err) {
    return err;
  }
}
